// extracted by mini-css-extract-plugin
export default {"chart":"bj_Pr","fullscreen":"bj_fd","close":"bj_p8"};